import { Grow, Grid, FormControlLabel, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SwapHorizRounded } from "@mui/icons-material";
import { withRouter } from "react-router-dom";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import AddButton from "../../components/AddButton/AddButton";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { getList, getTechnicianList } from "../../store/actions/PlannedMaintenanceListActions";
import { getToBePlanneds, getRecordStatusList, deleteToBePlanned } from "../../store/actions/ToBePlannedActions";
import { useDispatch, useSelector } from "react-redux";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

let createdbyme = [];
const ss = sessionStorage;

function ToBePlanned(props) {
    let [rows, setRows] = useState([]);
    const [rowsLength, setRowsLength] = useState(0);
    const { t } = useTranslation("translation");
    const [userID, setUserID] = useState();

    useEffect(() => {
        dispatch(getRecordStatusList());
        dispatch(getList());
        dispatch(getTechnicianList());
        const oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
        setUserID(oktaToken.idToken.claims.preferred_username.replace("@arcelik.com", ""));
        LoadHandler();
    }, []);

    const dispatch = useDispatch();

    const { ToBePlanned } = useSelector((ToBePlanned) => ToBePlanned);
    const { PlannedMaintenanceList } = useSelector((PlannedMaintenanceList) => PlannedMaintenanceList);
    let [localUserId, setLocalUserId] = useState([]);
    let [checkedMe, setCheckedMe] = useState(false);
    let [sortOrder, setSortOrder] = useState(0);
    let [sortColumn, setSortColumn] = useState("");

    useEffect(() => {
        LoadHandler();
    }, [checkedMe, sortColumn, sortOrder]);

    useEffect(() => {
        if (ToBePlanned?.toBePlannedList.errorCode === 0) {
            const { resultObject } = ToBePlanned.toBePlannedList;
            setRows(resultObject.content);
            setRowsLength(resultObject.totalCount);
        }
        if (ToBePlanned?.recordStatusList.length) {
            setRecordStatusList(ToBePlanned.recordStatusList);
        }
        if (ToBePlanned?.isTaskUpdated) {
            LoadHandler();
        }
    }, [ToBePlanned]);

    const [poolData, setPoolData] = useState([]);
    useEffect(() => {
        if (PlannedMaintenanceList.poolList) {
            setPoolData(Object.values(PlannedMaintenanceList.poolList));
        }
    }, [PlannedMaintenanceList.poolList]);

    useEffect(() => {
        if (PlannedMaintenanceList.technicianList) {
            setUserData(Object.values(PlannedMaintenanceList.technicianList));
            let res = Object.values(PlannedMaintenanceList.technicianList);
            if (res.length > 0) {
                setLocalUserId(res.filter((item) => item.userCode == userID)[0]?.id); //when switch change, set local user id for fetching data and filter
            }
        }
    }, [PlannedMaintenanceList.technicianList]);

    const LoadHandler = (pageNumber = currentPage, pageSize = rowsPerPage, filterCleared = false) => {
        const payload = {
            pageSize: pageSize,
            pageNumber: pageNumber + 1,
            data: {
                recordStatus: filterCleared ? 0 : recordStatus,
                notes: filterCleared ? "" : maintenanceNote,
                areaId: filterCleared ? 0 : machineStates.selectedAreaCode ?? 0,
                creatorIds: creatorIds ? creatorIds : [],
                poolIds: poolIds ? poolIds : [],
                machineId: filterCleared ? 0 : machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
                sortItem: {
                    propertyName: sortColumn,
                    direction: sortOrder,
                },
            },
        };
        dispatch(getToBePlanneds(payload));
    };

    //delete
    const DeleteHandler = (row) => {
        ToggleModal();
        dispatch(deleteToBePlanned(row.id));
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const HandleChangePage = (_event, newPage) => {
        setCurrentPage(newPage);
        LoadHandler(newPage, rowsPerPage);
    };

    const HandleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setCurrentPage(0);
        LoadHandler(0, event.target.value);
    };

    // Machine popup
    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "tbp",
            selectedAreaCode: isCleared ? null : ss.getItem("tbp_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("tbp_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("tbp_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("tbp_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("tbp_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("tbp_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);
    const HandleClearMachineStates = () => {
        ss.removeItem("tbp_selectedAreaCode");
        ss.removeItem("tbp_selectedAreaName");
        ss.removeItem("tbp_selectedMainEquipmentCode");
        ss.removeItem("tbp_selectedMainEquipmentName");
        ss.removeItem("tbp_selectedSubEquipmentCode");
        ss.removeItem("tbp_selectedSubEquipmentName");
        setMachineStates(initialMachineStates(true));
    };

    const [userData, setUserData] = useState([]);
    let [creatorIds, setCreatorIds] = useState([]);
    // set creator for filter
    const HandleCreatorName = (creatorName) => {
        let ids = [];
        creatorName.map((item) => ids.push(item.id));
        if (creatorName == null) {
            setCreatorIds([]);
        } else {
            setCreatorIds(ids);
            if (ids.length == 0 || ids.length >= 2) {
                setCheckedMe(false);
            }
        }
    };

    let [maintenanceNote, setMaintenanceNote] = useState("");
    const FilterWithMaintenanceNote = (e) => {
        setMaintenanceNote(e.target.value);
    };

    //set pool
    let [poolIds, setPoolIds] = useState("");
    const HandlePool = (poolName) => {
        let ids = [];
        poolName.map((item) => ids.push(item.id));
        setPoolIds(ids);
    };

    const [recordStatusList, setRecordStatusList] = useState([]);
    let [recordStatus, setRecordStatus] = useState(0);
    const HandleRecordStatusChange = (recordStatusName) => {
        const filteredRecordStatus = recordStatusList.filter((item) => item.description === recordStatusName)[0];
        setRecordStatus(filteredRecordStatus.code);
    };

    const HandleAssignToMe = (event) => {
        setCheckedMe(event.target.checked);
        if (event.target.checked) {
            setCreatorIds([localUserId]);
        } else {
            setCreatorIds([]);
        }
        setCurrentPage(0);
    };

    const NavigateToCreatePage = () => {
        props.history.push("/create-to-be-planned");
    };

    const NavigateAsEditable = (id) => {
        props.history.push("/create-to-be-planned?id=" + id);
    };

    const NavigateCreatePlannedMaintenance = (id) => {
        props.history.push("/create-planned-maintenance?from=toBePlanned&id=" + id);
    };

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const DeleteButtonHandler = (row) => {
        setDeletedRow(row);
        ToggleModal();
    };

    const ToggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    //dynamic sort function

    const HandleSort = (order, column) => {
        setSortOrder(order);
        setSortColumn(column);
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 0 ? "asc" : "desc";

        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return (
                    <TableCell id={`tbp_rowItems_TableCell_Actions_${index}_${item.id}`} align="center">
                        {item.label}
                    </TableCell>
                );
            } else {
                return isSortingAction ? (
                    <TableCell id={`tbp_rowItems_TableCell_${index}_${item.id}`} align="center">
                        <TableSortLabel
                            id={`tbp_rowItems_TableSortLabel_${index}_${item.id}`}
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() => HandleSort(sortOrder === 1 ? 0 : 1, item.id)}
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    const HandleApplyFilter = () => {
        LoadHandler();
    };

    const HandleClearFilter = () => {
        HandleClearMachineStates();
        setMaintenanceNote("");
        setRecordStatus(0);
        setCreatorIds([]);
        setPoolIds([]);
        LoadHandler(currentPage, rowsPerPage, true);
        setCheckedMe(false);
    };

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setIsFilterDrawerOpen(open);
    };

    const filter = () => {
        return (
            <DetailFilter
                HandleRecordStatusChange={HandleRecordStatusChange}
                recordStatusList={recordStatusList}
                recordStatus={recordStatus}
                HandlePool={HandlePool}
                poolData={poolData}
                poolIds={poolIds}
                HandleCreatorName={HandleCreatorName}
                creatorName={creatorIds}
                isMultipleDeclarative={true}
                userData={userData}
                FilterWithPlanNote={FilterWithMaintenanceNote}
                planNote={maintenanceNote}
                setMachineStates={setMachineStates}
                machineStates={machineStates}
            />
        );
    };

    return (
        <StyledTableDiv>
            <h1>{t("ToBePlanned")}</h1>
            <FilterDrawer
                open={isFilterDrawerOpen}
                onOpen={toggleDrawer(true)}
                onClose={toggleDrawer(false)}
                HandleClearFilter={HandleClearFilter}
                HandleApplyFilter={() => {
                    setIsFilterDrawerOpen(false);
                    HandleApplyFilter();
                }}
                detailFilter={filter()}
            />
            <Grid id="bl_Grid_3" item xs={!isMobile ? 4 : 6} style={{ marginBottom: 10 }}>
                <FormControlLabel
                    id="bl_formControl_2"
                    control={<Switch id="bl_CheckMe" checked={checkedMe} onChange={HandleAssignToMe} color="primary" name="checkedMe" inputProps={{ "aria-label": "primary checkbox" }} />}
                    label={t("CreatedByMe")}
                />
            </Grid>
            <FilterButton onClick={() => toggleDrawer(true)} />
            <AddButton onClick={() => NavigateToCreatePage()} />
            {rows.length ? (
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                    <TableContainer id="tbp_TableContainer" component={Paper}>
                        <Table id="tbp_Table" aria-label="customized table">
                            <TableHead id="tbp_TableHead">
                                <TableRow id="tbp_TableRow">
                                    {isMobile
                                        ? renderTableCell([
                                              { id: "EquipmentCode", label: t("EquipmentCode") },
                                              { id: "EquipmentName", label: t("EquipmentName") },
                                              { id: "PoolName", label: t("Pool") },
                                              { id: "MaintenanceTypeName", label: t("MaintenanceType") },
                                              { id: "Notes", label: t("MaintenanceNote") },
                                              { id: "RecordStatus", label: t("RecordStatus") },
                                              { id: "Actions", label: t("Actions") },
                                          ])
                                        : renderTableCell([
                                              { id: "Id", label: t("ID") },
                                              { id: "EquipmentCode", label: t("EquipmentCode") },
                                              { id: "EquipmentName", label: t("EquipmentName") },
                                              { id: "PoolName", label: t("Pool") },
                                              { id: "MaintenanceTypeName", label: t("MaintenanceType") },
                                              { id: "Notes", label: t("MaintenanceNote") },
                                              { id: "CreatorName", label: t("Creator") },
                                              { id: "plannedPersonCount", label: t("PlannedPersonCount") },
                                              { id: "plannedHoursPerPerson", label: t("Person/Hour") },
                                              { id: "RecordStatus", label: t("RecordStatus") },
                                              { id: "Actions", label: t("Actions") },
                                          ])}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.slice().map((row, index) => (
                                    <TableRow id={`tbp_TableRow_2_${index}`} key={row.id}>
                                        {!isMobile ? (
                                            <TableCell id={`tbp_TableCell_id`} align="center">
                                                {row.id}
                                            </TableCell>
                                        ) : null}
                                        <TableCell id={`tbp_TableCell_eqCode`} align="center">
                                            {row.equipmentCode}
                                        </TableCell>
                                        <TableCell id={`tbp_TableCell_eqName`} align="center">
                                            {row.equipmentName}
                                        </TableCell>
                                        <TableCell id={`tbp_TableCell_poolName`} align="center">
                                            {row.poolName}
                                        </TableCell>
                                        <TableCell id={`tbp_TableCell_mtypeName`} align="center">
                                            {row.maintenanceTypeName}
                                        </TableCell>
                                        <TableCell id={`tbp_TableCell_notes`} align="center">
                                            {row.notes}
                                        </TableCell>
                                        {!isMobile ? (
                                            <TableCell id={`tbp_TableCell_creatorName`} align="center">
                                                {row.creatorName}
                                            </TableCell>
                                        ) : null}
                                        {!isMobile ? (
                                            <TableCell id={`tbp_TableCell_ppCount`} align="center">
                                                {row.plannedPersonCount}
                                            </TableCell>
                                        ) : null}
                                        {!isMobile ? (
                                            <TableCell id={`tbp_TableCell_phperPerson`} align="center">
                                                {row.plannedHoursPerPerson}
                                            </TableCell>
                                        ) : null}
                                        <TableCell id={`tbp_TableCell_recordStatus`} align="center">
                                            {row.recordStatusDesc ?? row.recordStatus}
                                        </TableCell>
                                        <TableButtons
                                            id="tbp_TableButtons`"
                                            table={"PlannedMaintenance"}
                                            row={row}
                                            icon={<SwapHorizRounded />}
                                            title={t("ConvertToPlannedMaintenance")}
                                            enableEditHandler={() => NavigateAsEditable(row.id)}
                                            deleteButtonHandler={() => DeleteButtonHandler(row)}
                                            navigateCreateCopy={() => NavigateCreatePlannedMaintenance(row.id)}
                                            detail={false}
                                        />
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            id="tbp_TablePagination"
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rowsLength}
                            rowsPerPage={rowsPerPage}
                            page={currentPage}
                            onPageChange={HandleChangePage}
                            onRowsPerPageChange={HandleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}

            <Modal id="tbp_Modal" title={t("Delete")} content={t("WillYouDoTransaction")} approved={() => DeleteHandler(deletedRow)} isModalOpen={isModalOpen} toggle={ToggleModal} />
            <LoadingBackdrop id="tbp_lbd" />
        </StyledTableDiv>
    );
}

export default withRouter(ToBePlanned);
